import React from 'react';
import { translate } from '../../../../types/translation/Translator';
import InnerFilterContent, { FilterInnerContentProps } from '../common/DropdownContent/DynamicFilterInnerContent';

export default function CompanyStatusFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<string>) {
  return (
    <InnerFilterContent
      filter={filter}
      filterProps={{ filterProps, setFilterProps }}
      items={[...(filterProps.companyStatus || [])]}
      text={item => translate({ key: item as any })}
      onRemove={i => {
        filterProps.companyStatus?.delete(i);
        if (!filterProps.companyStatus?.size) filterProps.companyStatus = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
